export enum Effects {
  DropShadow = '0px 5px 15px rgba(0, 0, 0, 0.05)',
}
